module.exports = __webpack_public_path__ + "img/119.0d42d422.svg";